import axios from 'axios'

import { ApiConstants } from '../constants/ApiConstant'

class ApiService {
  public get(endpoint: string): Promise<any> {
    const url: string = `${ApiConstants.baseUrl}${endpoint}`
    const getPromise = axios.get(url)
    return getPromise.then((response) => response.data)
  }

  public put(endpoint: string, payload: any, options?: any): Promise<any> {
    const url: string = `${ApiConstants.baseUrl}${endpoint}`
    const putPromise = axios.put(url, payload, {
      signal: options?.signal,
      headers: {
        'Content-Type': 'application/json',
      },
    })
    return putPromise.then((response) => response?.data)
  }

  public post(endpoint: string, payload: any): Promise<any> {
    const url: string = `${ApiConstants.baseUrl}${endpoint}`
    const postPromise = axios.post(url, payload)

    return postPromise.then((response) => response?.data)
  }

  public delete(endpoint: string, payload: any): Promise<any> {
    const url: string = `${ApiConstants.baseUrl}${endpoint}`
    const deletePromise = axios.delete(url, { data: payload })
    return deletePromise.then((response) => response)
  }

  public getFile(path: string): Promise<any> {
    const url: string = `${path}`
    const getPromise = axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    return getPromise.then((response) => response.data)
  }
}

export default ApiService
